import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  filterFieldsForItemTemplate,
  filterFieldsForItemList,
  filterSystemCreatedFieldsForItemList,
} from 'drapcode-constant';
import { toast } from 'react-toastify';
import { CSVDownloader } from 'react-papaparse';
import * as moment from 'moment';
import * as actions from './redux/actions';
import UploadCsvPreview from './item/import/UploadCsvPreview';
import UploadCsv from './item/import/UploadCsv';
import CustomLoader from '../common/CustomLoader';
import * as importActions from '../import/redux/actions';
import EnvironmentSelect from '../../common/formElements/EnvironmentSelect';
import { excludedFields, filterUserCreatedFieldsForItemList } from '../common/FieldTypes';
import ParentDocCard from '../common/ParentDocCard';
import { drapcodeIcon, drapcodeImgIcon } from '../../common/custom/icon-library';
import CollectionHeaderNav from './CollectionHeaderNav';

export class ImportCollectionData extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    isFileUploaded: false,
    fields: [],
    data: [],
    csvHeader: [],
    csvData: [],
    mappedFields: [],
    limit: 25,
    titleToFieldNameMap: {},
    csvHeaderTitles: [],
  };

  componentDidMount() {
    const { projectId, collectionId, version } = this.props.match.params;
    this.props.importActions.saveCsvFileData({ data: [], fields: [] });
    this.props.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
  }

  handleOnDrop = (data, file) => {
    const { importActions, collections } = this.props;
    const { selectedCollection } = collections;
    const titleToFieldNameMap = {};
    const fieldTitleList = [];
    const fieldNameList = [];
    selectedCollection.fields.forEach((field) => {
      const title = (field.fieldTitle && field.fieldTitle.en) || field.fieldName;
      if (!excludedFields.includes(field.fieldName)) {
        fieldTitleList.push(title);
        fieldNameList.push(field.fieldName);
      }
      titleToFieldNameMap[title] = field.fieldName;
    });
    const parsedData = data.map((row) => {
      const newData = {};
      Object.entries(row.data).forEach(([title, value]) => {
        const fieldName = title;
        if (fieldName) {
          try {
            const parsedValue = JSON.parse(value);
            newData[fieldName] = Array.isArray(parsedValue) ? parsedValue[0] : parsedValue;
          } catch {
            newData[fieldName] = value;
          }
        }
      });
      return {
        ...row,
        data: newData,
        meta: {
          ...row.meta,
          fields: row.meta.fields.map((title) => titleToFieldNameMap[title] || title),
        },
      };
    });
    if (fieldNameList.length > 0) {
      const finalObj = {
        data: parsedData,
        fields: fieldNameList,
      };
      this.setState({
        ...finalObj,
        csvHeaderTitles: fieldTitleList,
        titleFieldMap: titleToFieldNameMap,
      });
      importActions.saveCsvFileData(finalObj);
      toast.success('The CSV file validated successfully!', {});
    } else {
      toast.error('Validation failed! Collection fields not found.', {});
    }
  };

  handleOnError = (err, file, inputElem, reason) => {
    console.error(err);
  };

  handleOnRemoveFile = (data) => {
    console.log(data);
  };

  handleSubmit = async () => {
    const { collections, match, importActions, actions, history } = this.props;
    const { selectedCollection } = collections;
    const { collectionName } = selectedCollection;
    const { projectId, collectionId, version } = match.params;
    let formData = {
      csvData: this.props.import.csvData,
      mappedFields: this.props.import.csvHeader,
    };
    await importActions.importItemsFromCsvData({
      projectId,
      version,
      formData,
      collectionName,
    });
    await actions.loadCollectionItems({
      projectId,
      collectionName,
      collection: selectedCollection,
      limit: this.state.limit,
      version,
    });
    history.push(
      `/collections/${version}/v/${projectId}/items/${collectionId}/name/${collectionName}`,
    );
  };

  handleCancel = () => {
    const { collections, match, importActions, actions, history } = this.props;
    const { selectedCollection } = collections;
    const { collectionName } = selectedCollection;
    const { projectId, collectionId, version } = match.params;
    importActions.saveCsvFileData({ data: [], fields: [] });
    history.push(
      `/collections/${version}/v/${projectId}/items/${collectionId}/name/${collectionName}`,
    );
  };

  templateFile = (collectionTitle) => {
    let fileName = 'Template';
    let templateTimestamp = moment().format('YYYY-MM-DD-HH-mm-ss-SSS');
    fileName = `${fileName}${templateTimestamp}`;
    if (collectionTitle) {
      fileName = `${collectionTitle}${fileName}`;
    }
    return fileName;
  };

  itemDataJSON = (fields) => {
    let systemCreatedFields = filterSystemCreatedFieldsForItemList(fields);
    let userCreatedFields = filterUserCreatedFieldsForItemList(fields);
    let userAndSystemCreatedFields = [...userCreatedFields, ...systemCreatedFields];
    let itemData = [];
    let itemTemp = {};
    userAndSystemCreatedFields.forEach((element) => {
      itemTemp[element.fieldName] = `REPLACE_${element.fieldName}_HERE`;
    });
    for (let i = 0; i < 3; i++) {
      itemData.push(itemTemp);
    }
    return itemData;
  };

  uploadCsvdata() {
    const { csvData, csvHeader, importItemsFromCsvDataPending, importItemsFromCsvDataError } =
      this.props.import;
    return (
      <div className="text-center flex-end">
        <button
          type="button"
          className="btn btn-outline btn-md  "
          onClick={() => this.handleCancel()}
          title="Cancel CSV Import"
        >
          <i className="wb webconnect-times"> </i> Cancel
        </button>
        &nbsp;
        {csvData.length > 0 && csvHeader.length > 0 && (
          <button
            type="button"
            className="btn btn-theme-submit btn-md"
            onClick={this.handleSubmit}
            title="Import CSV Content"
          >
            <i className="wb webconnect-upload"></i>
            &nbsp;Import
            <CustomLoader loading={importItemsFromCsvDataPending === true} />
          </button>
        )}
      </div>
    );
  }
  reloadItemForm = () => {
    const { refreshItemForm } = this.props;
    if (refreshItemForm) {
      refreshItemForm();
    }
  };
  renderCollectionItem = () => {
    const { collections, match } = this.props;
    const { csvData, csvHeader, importItemsFromCsvDataPending, importItemsFromCsvDataError } =
      this.props.import;
    const { csvHeaderTitles, titleFieldMap } = this.state;
    const { params } = match || '';
    const { projectId, version } = params || '';
    const { loadProjectCollectionDetailPending } = collections;
    const { selectedCollection } = collections ? collections : '';
    if (selectedCollection) {
      let { fields, collectionTitle } = selectedCollection;
      fields = filterFieldsForItemList(fields);
      let itemData = this.itemDataJSON(fields);
      return (
        <>
          <CollectionHeaderNav
            label="CSV"
            projectId={projectId}
            version={version}
            selectedCollection={selectedCollection}
            uploadHeaders
          />
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <div className="card">
              <div
                className="card-header card-header-icon"
                data-background-color="drapcode-dark-blue"
              >
                <i className={`wb ${drapcodeIcon('dbExport')}`}></i>
              </div>
              <div className="card-title-header pt-3 d-flex justify-content-evenly">
                <div>
                  {' '}
                  <h4 className="card-title">Import Items From CSV</h4>
                </div>
                <div className="col-5"> </div>
                <div className="card-title text-center">
                  <button className="btn btn-primary btn-md mr-2">
                    <CSVDownloader
                      data={itemData}
                      type="link"
                      filename={this.templateFile(collectionTitle)}
                      bom={true}
                      className="no-hover"
                    >
                      <i className="wb webconnect-download"></i> Download CSV Template
                    </CSVDownloader>
                  </button>
                </div>
                <div className="col-3 mt-8">
                  <EnvironmentSelect
                    projectId={projectId}
                    version={version}
                    refreshMethod={() => this.reloadItemForm()}
                  />
                </div>
              </div>
              <div className="row mx-auto">
                <div className="col-12">
                  <div className="row mx-auto">
                    <div className="offset-md-0 col-12">
                      {csvData.length > 0 && csvHeader.length > 0 ? (
                        <div className="card-body">
                          <UploadCsvPreview
                            csvHeader={csvHeaderTitles}
                            csvData={csvData}
                            titleFieldMap={titleFieldMap}
                          />
                        </div>
                      ) : (
                        <div className="card-body mt-5">
                          <UploadCsv
                            handleOnDrop={this.handleOnDrop}
                            handleOnError={this.handleOnError}
                            handleOnRemoveFile={this.handleOnRemoveFile}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer d-flex  justify-content-start mt-4 pt-4 ">
                {this.uploadCsvdata()}
              </div>
            </div>
          </div>
          <ParentDocCard>
            <h5>
              <b>About CSV Data </b>
            </h5>
            <p>
              A comma-separated values CSV file is a delimited text file that uses a comma to
              separate values. Each line of the file is a data record. Each record consists of one
              or more fields, separated by commas. The use of the comma as a field separator is the
              source of the name for this file format. A CSV file typically stores tabular data
              (numbers and text) in plain text, in which case each line will have the same number of
              fields.
            </p>
          </ParentDocCard>
        </>
      );
    } else if (loadProjectCollectionDetailPending) {
      return '';
    } else {
      return 'No Collection Found';
    }
  };

  render() {
    return (
      <div className="main">
        <div className="section">
          <div className="container">{this.renderCollectionItem()}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    import: state.import,
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    importActions: bindActionCreators({ ...importActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportCollectionData);
